const KEY = "cardark-theme";

export const getTheme = () => {
  try {
    return localStorage.getItem(KEY) || "dark";
  } catch {
    return "dark";
  }
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("light", theme === "light");
};

export const setTheme = (theme) => {
  try {
    localStorage.setItem(KEY, theme);
  } catch {}
  applyTheme(theme);
};

const SIZE_KEY = "cardark-textsize";
const TEXT_SIZES = { default: "16px", large: "17.5px", xl: "19px" };

export const getTextSize = () => {
  try {
    return localStorage.getItem(SIZE_KEY) || "default";
  } catch {
    return "default";
  }
};

export const applyTextSize = (size) => {
  document.documentElement.style.fontSize = TEXT_SIZES[size] || TEXT_SIZES.default;
};

export const setTextSize = (size) => {
  try {
    localStorage.setItem(SIZE_KEY, size);
  } catch {}
  applyTextSize(size);
};

const MOTION_KEY = "cardark-reduce-motion";

export const getReduceMotion = () => {
  try {
    return localStorage.getItem(MOTION_KEY) === "1";
  } catch {
    return false;
  }
};

export const applyReduceMotion = (on) => {
  document.documentElement.classList.toggle("reduce-motion", on);
};

export const setReduceMotion = (on) => {
  try {
    localStorage.setItem(MOTION_KEY, on ? "1" : "0");
  } catch {}
  applyReduceMotion(on);
};

applyTheme(getTheme());
applyTextSize(getTextSize());
applyReduceMotion(getReduceMotion());
